import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { ProductTopBanner } from "../components/ProductTopBanner";
import { TaskFormSubjective } from "../components/TaskFormSubjective";

export const ProductTask = () => {
  return (
    <>
      <PageTitle pageName={pageName.product.task} />
      <ProductTopBanner buttonType="back" />
      <TaskFormSubjective />
    </>
  );
};
